import {
    SET_REFRESH,
    DASHBOARD_REFRESH
} from "../../constants/dashboard";


export const setRefresh = (refreshing) => ({
    type: SET_REFRESH,
    refreshing
})

export const refreshDashboard = (needsRefresh) => ({
    type: DASHBOARD_REFRESH,
    needsRefresh
})